import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { DrawerDialog } from '@/common/components/drawer-dialog';
import React from 'react';
import InfoThick from '@/icons/info-thick';
import { ButtonBlob } from '@/common/components/button-blob';
import InsuranceDetailsContent, {
  InsuranceDetailsContentProps,
} from './insurance-details-content';
import { Button } from '@/shadcn-ui/button';
import { InsurancePlan } from '@/catalog/types';

export interface InsuranceDetailsDrawerDialogProps extends InsuranceDetailsContentProps {
  triggerVariant?: 'button' | 'info-blob' | 'custom';
  customTrigger?: React.JSX.Element;
  className?: string;
  disabled?: boolean;
  enableInsuranceChange?: boolean;
  insurancePlans?: InsurancePlan[];
}

export default function InsuranceDetailsDrawerDialog({
  triggerVariant = 'button',
  variant,
  customTrigger,
  disabled,
  className,
  enableInsuranceChange,
  insurancePlans,
}: InsuranceDetailsDrawerDialogProps) {
  const trigger =
    triggerVariant === 'button' ? (
      <Button
        className={cn(className, {
          'cursor-default': disabled,
          'cursor-pointer': !disabled,
        })}
        variant={'clear'}
        disabled={disabled}
      >
        <InfoThick color={colors.blue30} />
      </Button>
    ) : triggerVariant === 'custom' && customTrigger ? (
      customTrigger
    ) : (
      <ButtonBlob buttonVariant="info">
        <p className="body-strong">Insurance and protection details</p>
      </ButtonBlob>
    );

  return (
    <>
      <DrawerDialog trigger={trigger} title="Protection plan details">
        <InsuranceDetailsContent
          variant={variant}
          enableInsuranceChange={enableInsuranceChange}
          insurancePlans={insurancePlans}
        />
      </DrawerDialog>
    </>
  );
}
